// ...existing code...
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
    get_Enrolled_Course_List_By_Tab,
    Get_Student_FirstCourse_CompletedLessons,
    Get_Recordings,
} from "Service/parent";
import { useSearchParams } from "react-router-dom";
import styles from "./Response.module.scss";
import Report from "Assets/Report.png";
import video from "Assets/video.png";
import useStore from "store";
// import Moment from react-moment;
import moment from "moment-timezone";
import Moment from "react-moment";

// import Styles from "./Response.module.scss";
type EnrolledCourse = {
    ParentID: number;
    StudentID: number;
    RelationWithParent: string;
    EnrollCourseID: number;
    BatchStudentStatus: number;
    CourseID: number;
    BatchID: number;
    BatchName: string;
    CourseName: string;
    BatchStatus: string;
    BatchStatusLabel: string;
};

const TABS = ["Active", "Completed", "Discontinued"] as const;
type Tab = (typeof TABS)[number];

function Resource() {
    const { timeZone } = useStore((item: any) => item);

    const [query] = useSearchParams();
    const navigate = useNavigate();
    const studentId = query?.get("StudentId") || query.get("studentid") || "";
    console.log(studentId);
    const [tab, setTab] = useState<Tab>("Active");
    const [loading, setLoading] = useState(false);
    const [Lessonloading, setLessonLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [CurrentResourceName, setCurrentResourceName] = useState<string>("");
    const [courses, setCourses] = useState<EnrolledCourse[]>([]);
    const [classes, setClasses] = useState<any[]>([]);
    const [reportModalOpen, setReportModalOpen] = useState(false);
    const [reportRow, setReportRow] = useState<any | null>(null);
    const [recordModalOpen, setRecordModalOpen] = useState(false);
    const [recordList, setRecordList] = useState<any[]>([]);
    const closeBtnRef = useRef<HTMLButtonElement | null>(null);

    // close modal on Escape and focus management
    useEffect(() => {
        function onKey(e: KeyboardEvent) {
            if (e.key === "Escape") {
                if (reportModalOpen) setReportModalOpen(false);
                if (recordModalOpen) setRecordModalOpen(false);
            }
        }
        if (reportModalOpen || recordModalOpen) {
            document.addEventListener("keydown", onKey);
            // focus the close button when modal opens
            setTimeout(() => closeBtnRef.current?.focus(), 50);
        }
        return () => document.removeEventListener("keydown", onKey);
    }, [reportModalOpen, recordModalOpen]);

    const ComepletedCourses = async (
        tab: any,
        studentId: any,
        CourseId: any,
        BatchID: any
    ) => {
        const token = {
            Authorization: `token ${localStorage.getItem("learn2readToken")}`,
        };
        try {
            setLessonLoading(true);
            const json = await Get_Student_FirstCourse_CompletedLessons(
                "GET",
                null,
                token,
                tab,
                studentId,
                CourseId,
                BatchID
            );

            if (json?.Status !== 1) {
                setClasses([]);
                setError(json?.Message || "API returned non success status");
            } else {
                setClasses(json?.CompletedLessons || []);
            }
        } catch (e: any) {
            setError(e.message || "Network error");
            setCourses([]);
        } finally {
            setLoading(false);
            setLessonLoading(false);
        }
    };

    useEffect(() => {
        if (!studentId) {
            setError("StudentID query param is required.");
            setCourses([]);
            return;
        }

        async function fetchCourses() {
            setLoading(true);
            setError(null);
            // token header object expected by Service functions
            const token = {
                Authorization: `token ${localStorage.getItem(
                    "learn2readToken"
                )}`,
            };

            try {
                console.log("Fetching courses for StudentID:");
                const json = await get_Enrolled_Course_List_By_Tab(
                    "GET",
                    null,
                    token,
                    studentId,
                    tab
                );

                if (json?.Status !== 1) {
                    setCourses([]);
                    setError(
                        json?.Message || "API returned non success status"
                    );
                } else {
                    // API sometimes returns EnrolledCourses or Courses
                    console.log("Fetched courses:", json);
                    setCourses(json.EnrolledCourses || json.Courses || []);
                    if (json.EnrolledCourses.length > 0) {
                        ComepletedCourses(
                            tab,
                            studentId,
                            json.EnrolledCourses[0]?.CourseID,
                            json.EnrolledCourses[0]?.BatchID
                        );
                        setSelectedCourse(json.EnrolledCourses[0]?.BatchID);
                        setCurrentResourceName(
                            json.EnrolledCourses[0]?.CourseName
                        );
                    } else {
                        setCurrentResourceName("");
                    }
                }
            } catch (e: any) {
                setError(e.message || "Network error");
                setCourses([]);
            } finally {
                setLoading(false);
            }
        }

        fetchCourses();
    }, [tab, studentId]);

    // helper to change tab and keep query param (optional)
    function handleTab(t: Tab) {
        setTab(t);
    }

    const [selectedCourse, setSelectedCourse] = useState<number | null>(null);

    // derive unique course names for pill buttons
    const courseNames = Array.from(
        new Set(courses.map((c) => c.CourseName))
    ).filter(Boolean);

    // useEffect(() => {
    //     if (!selectedCourse && courseNames.length)
    //         setSelectedCourse(courseNames[0]?.BatchID);
    // }, [courseNames]);
    return (
        <div className={styles.container}>
            {/* Top tab bar */}
            <div className={styles.topTabs}>
                <div className={styles.tabsLeft}>
                    {TABS.map((t) => (
                        <button
                            key={t}
                            onClick={() => handleTab(t)}
                            className={`${styles.tabBtn} ${
                                t === tab ? styles.tabBtnActive : ""
                            }`}>
                            {t == "Active" ? "Ongoing" : t} Courses
                        </button>
                    ))}
                </div>

                <div style={{ flex: 1 }} />
            </div>

            {/* Main white card */}
            <div className={styles.card}>
                {/* Breadcrumb + course pills */}
                {/*   <div className={styles.breadcrumb}>
                    <div>
                        Resources / {tab} Courses {CurrentResourceName && "/"}{" "}
                        <span style={{ fontWeight: 600 }}>
                            {CurrentResourceName}
                        </span>
                    </div>
                </div> */}
                <div className={styles.coursePills}>
                    {loading ? (
                        <p></p>
                    ) : courses && courses.length ? (
                        courses.map((name) => (
                            <button
                                key={`${name.CourseID}-${name.EnrollCourseID}`}
                                onClick={() => {
                                    ComepletedCourses(
                                        tab,
                                        studentId,
                                        name.CourseID,
                                        name.BatchID
                                    );
                                    setSelectedCourse(name.BatchID);

                                    setCurrentResourceName(name?.CourseName);
                                }}
                                className={`${styles.pill} ${
                                    selectedCourse === name.BatchID
                                        ? styles.pillActive
                                        : ""
                                }`}>
                                {name.CourseName}
                                {name.BatchStudentStatus == 0 && (
                                    <span style={{ color: "red" }}>
                                        {" "}
                                        (old Batch)
                                    </span>
                                )}
                            </button>
                        ))
                    ) : (
                        <div className={styles.empty}>No courses</div>
                    )}
                </div>

                {/* Table container */}
                <div className={styles.tableWrap}>
                    <div className={styles.tableInner}>
                        {loading && (
                            <div className={styles.empty}>Loading...</div>
                        )}
                        {error && (
                            <div style={{ color: "crimson", marginBottom: 12 }}>
                                {error}
                            </div>
                        )}

                        {/*   {!loading && !error && courses.length === 0 && (
                            <div className={styles.empty}>
                                No courses found for StudentID: {studentId}
                            </div>
                        )} */}

                        {!Lessonloading && !loading && courses.length > 0 && (
                            <table className={styles.table}>
                                <thead>
                                    <tr className={styles.theadRow}>
                                        <th className={styles.th}>
                                            Class Date Time
                                        </th>
                                        <th
                                            className={styles.th}
                                            style={{ width: 60 }}>
                                            Topic
                                        </th>
                                        <th className={styles.th}>Song </th>
                                        <th className={styles.th}>Story </th>
                                        <th className={styles.th}>Homework</th>
                                        <th className={styles.th}>Game </th>
                                        <th className={styles.th}>Worksheet</th>
                                        <th className={styles.th}>Recording</th>
                                        <th className={styles.th}>
                                            Class Report
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {classes?.length > 0 ? (
                                        classes?.map((c, i) => (
                                            <tr
                                                key={c.EnrollCourseID}
                                                style={{
                                                    borderBottom:
                                                        "1px solid #f0f2f6",
                                                }}>
                                                <td
                                                    className={styles.td}
                                                    style={{ width: "7rem" }}>
                                                    <Moment
                                                        format="DD MMM YYYY"
                                                        tz={
                                                            timeZone ||
                                                            moment.tz.guess()
                                                        }>
                                                        {`${
                                                            c?.Scheduled_StartDate?.split(
                                                                "T"
                                                            )[0]
                                                        }T${
                                                            c?.Scheduled_StartTime
                                                        }+05:30`}
                                                    </Moment>
                                                    <br />
                                                    <Moment
                                                        format="hh:mm a"
                                                        tz={
                                                            timeZone ||
                                                            moment.tz.guess()
                                                        }>
                                                        {`${
                                                            c?.Scheduled_StartDate?.split(
                                                                "T"
                                                            )[0]
                                                        }T${
                                                            c?.Scheduled_StartTime
                                                        }+05:30`}
                                                    </Moment>
                                                </td>
                                                <td
                                                    className={styles.td}
                                                    style={{ width: "7rem" }}>
                                                    File-{c?.PlanNumber}
                                                </td>
                                                <td className={styles.td}>
                                                    {c?.SongURLs?.length == 0
                                                        ? "No song"
                                                        : c?.SongURLs?.map(
                                                              (
                                                                  item: any,
                                                                  index: number
                                                              ) => (
                                                                  <>
                                                                      <a
                                                                          href={
                                                                              item.ResourceUrl
                                                                          }
                                                                          target="_blank"
                                                                          style={{
                                                                              color: "#6f2fa8",
                                                                              textDecoration:
                                                                                  "underline",
                                                                          }}>
                                                                          {
                                                                              item?.ResourceName
                                                                          }
                                                                      </a>
                                                                      {index !==
                                                                          c
                                                                              ?.SongURLs
                                                                              .length -
                                                                              1 && (
                                                                          <br />
                                                                      )}
                                                                  </>
                                                              )
                                                          )}
                                                </td>

                                                <td className={styles.td}>
                                                    {c?.StoryURLs.length == 0
                                                        ? "No Story"
                                                        : c?.StoryURLs?.map(
                                                              (
                                                                  item: any,
                                                                  index: number
                                                              ) => (
                                                                  <>
                                                                      <a
                                                                          href={
                                                                              item.ResourceUrl
                                                                          }
                                                                          target="_blank"
                                                                          style={{
                                                                              color: "#6f2fa8",
                                                                              textDecoration:
                                                                                  "underline",
                                                                          }}>
                                                                          {
                                                                              item?.ResourceName
                                                                          }
                                                                      </a>
                                                                      {index !==
                                                                          c
                                                                              ?.StoryURLs
                                                                              .length -
                                                                              1 && (
                                                                          <br />
                                                                      )}
                                                                  </>
                                                              )
                                                          )}
                                                </td>

                                                <td
                                                    className={`${styles.td}`}
                                                    style={{ width: "7rem" }}>
                                                    {c.HomeworkURLs &&
                                                    c.HomeworkURLs.length > 0
                                                        ? c.HomeworkURLs.map(
                                                              (
                                                                  item: any,
                                                                  index: any
                                                              ) => (
                                                                  <>
                                                                      <a
                                                                          href={
                                                                              item
                                                                          }
                                                                          target="_blank">
                                                                          Home
                                                                          Work -
                                                                          {index +
                                                                              1}
                                                                      </a>
                                                                      {index !==
                                                                          c
                                                                              ?.HomeworkURLs
                                                                              .length -
                                                                              1 && (
                                                                          <br />
                                                                      )}
                                                                  </>
                                                              )
                                                          )
                                                        : "No Homework"}
                                                </td>
                                                <td className={styles.td}>
                                                    {c?.GamesURL.length == 0
                                                        ? "No Game"
                                                        : c?.GamesURL?.map(
                                                              (
                                                                  item: any,
                                                                  index: number
                                                              ) => (
                                                                  <>
                                                                      <a
                                                                          href={
                                                                              item.ResourceUrl
                                                                          }
                                                                          target="_blank"
                                                                          style={{
                                                                              color: "#6f2fa8",
                                                                              textDecoration:
                                                                                  "underline",
                                                                          }}>
                                                                          {
                                                                              item?.ResourceName
                                                                          }
                                                                      </a>
                                                                      {index !==
                                                                          c
                                                                              ?.GamesURL
                                                                              .length -
                                                                              1 && (
                                                                          <br />
                                                                      )}
                                                                  </>
                                                              )
                                                          )}
                                                </td>
                                                <td
                                                    className={styles.td}
                                                    style={{ width: "7rem" }}>
                                                    {c?.WorksheetURLs.length ==
                                                    0
                                                        ? "No Worksheet"
                                                        : c?.WorksheetURLs?.map(
                                                              (
                                                                  item: any,
                                                                  index: number
                                                              ) => (
                                                                  <>
                                                                      <a
                                                                          href={
                                                                              item
                                                                          }
                                                                          target="_blank"
                                                                          style={{
                                                                              color: "#6f2fa8",
                                                                              textDecoration:
                                                                                  "underline",
                                                                          }}>
                                                                          Worksheet-{" "}
                                                                          {index +
                                                                              1}
                                                                      </a>
                                                                      {index !==
                                                                          c
                                                                              ?.WorksheetURLs
                                                                              .length -
                                                                              1 && (
                                                                          <span>
                                                                              <br />
                                                                          </span>
                                                                      )}
                                                                  </>
                                                              )
                                                          )}
                                                </td>
                                                <td
                                                    className={`${styles.td} ${styles.center}`}>
                                                    <button
                                                        className={
                                                            styles.playBtn
                                                        }
                                                        onClick={async () => {
                                                            const token = {
                                                                Authorization: `token ${localStorage.getItem(
                                                                    "learn2readToken"
                                                                )}`,
                                                            };
                                                            // Prefer calling API by ScheduleClassID if available
                                                            const scheduleId =
                                                                c?.ScheduleClassID ||
                                                                c?.ScheduleClass_Id ||
                                                                c?.ScheduleClassId ||
                                                                c?.ScheduleClass ||
                                                                c?.ScheduleClassID;
                                                            if (scheduleId) {
                                                                try {
                                                                    const json =
                                                                        await Get_Recordings(
                                                                            "GET",
                                                                            null,
                                                                            token,
                                                                            scheduleId
                                                                        );
                                                                    // API returns Recordings object with ZoomRestartData array
                                                                    const recordingsFromApi =
                                                                        json
                                                                            ?.Recordings
                                                                            ?.ZoomRestartData ||
                                                                        json?.Recordings ||
                                                                        [];
                                                                    setRecordList(
                                                                        recordingsFromApi ||
                                                                            []
                                                                    );
                                                                } catch (e) {
                                                                    // fallback to client-side data if API fails
                                                                    setRecordList(
                                                                        c?.ZoomRestartData ||
                                                                            []
                                                                    );
                                                                }
                                                            } else {
                                                                // no schedule id available, fallback
                                                                setRecordList(
                                                                    c?.ZoomRestartData ||
                                                                        []
                                                                );
                                                            }

                                                            setRecordModalOpen(
                                                                true
                                                            );
                                                        }}
                                                        aria-label={`Open recordings for ${
                                                            c?.PlanNumber || i
                                                        }`}>
                                                        <img
                                                            src={video}
                                                            alt=""
                                                        />
                                                    </button>
                                                </td>
                                                <td
                                                    className={`${styles.td} ${styles.center}`}>
                                                    <button
                                                        className={
                                                            styles.reportBtn
                                                        }
                                                        onClick={() => {
                                                            setReportRow(c);
                                                            setReportModalOpen(
                                                                true
                                                            );
                                                        }}
                                                        aria-label={`Open report for ${
                                                            c?.PlanNumber || i
                                                        }`}>
                                                        <img
                                                            src={Report}
                                                            alt=""
                                                        />
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td
                                                className={styles.td}
                                                colSpan={7}
                                                style={{
                                                    padding: "0.5rem",
                                                    textAlign: "center",
                                                }}>
                                                No Resources Found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        )}
                    </div>
                </div>
            </div>
            {reportModalOpen && reportRow && (
                <div
                    className={styles.modalOverlay}
                    role="dialog"
                    aria-modal="true">
                    <div className={styles.modalContent}>
                        <div className={styles.modalHeader}>
                            <h3>Report Card</h3>
                            <button
                                ref={closeBtnRef}
                                className={styles.closeBtn}
                                onClick={() => setReportModalOpen(false)}
                                aria-label="Close report modal">
                                ✕
                            </button>
                        </div>
                        <div className={styles.modalBody}>
                            {/* If NewTopicDone is an array, present it as a clean table */}
                            {Array.isArray(reportRow?.NewTopicDone) ? (
                                <div>
                                    <div
                                        className={styles.modalRow}
                                        style={{ paddingBottom: 8 }}>
                                        <div className={styles.label}>
                                            Topics
                                        </div>
                                        <div className={styles.content}>
                                            <table
                                                className={styles.reportTable}>
                                                <thead>
                                                    <tr>
                                                        <th
                                                            style={{
                                                                width: 40,
                                                            }}>
                                                            #
                                                        </th>
                                                        <th>Topic Taken</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {reportRow.NewTopicDone.map(
                                                        (
                                                            t: any,
                                                            idx: number
                                                        ) => (
                                                            <tr key={idx}>
                                                                <td>
                                                                    {idx + 1}
                                                                </td>
                                                                <td>{t}</td>
                                                            </tr>
                                                        )
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                    {/* Comments shown below as label/content */}
                                    <div
                                        className={styles.modalRow}
                                        style={{ paddingTop: 12 }}>
                                        <div className={styles.label}>
                                            Comments
                                        </div>
                                        <div className={styles.content}>
                                            {reportRow?.Comments || "-"}
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                /* Fallback: display as left-label / right-content */
                                <div>
                                    <div className={styles.modalRow}>
                                        <div className={styles.label}>
                                            Topic Taken
                                        </div>
                                        <div className={styles.content}>
                                            {reportRow?.NewTopicDone || "-"}
                                        </div>
                                    </div>
                                    <div className={styles.modalRow}>
                                        <div className={styles.label}>
                                            Comments
                                        </div>
                                        <div className={styles.content}>
                                            {reportRow?.Comments || "-"}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
            {recordModalOpen && (
                <div
                    className={styles.modalOverlay}
                    role="dialog"
                    aria-modal="true">
                    <div className={styles.modalContent}>
                        <div className={styles.modalHeader}>
                            <h3>Recordings</h3>
                            <button
                                ref={closeBtnRef}
                                className={styles.closeBtn}
                                onClick={() => setRecordModalOpen(false)}
                                aria-label="Close recordings modal">
                                ✕
                            </button>
                        </div>
                        <div className={styles.modalBody}>
                            {!recordList || recordList.length === 0 ? (
                                <div className={styles.empty}>
                                    No recordings available
                                </div>
                            ) : (
                                <table className={styles.reportTable}>
                                    <thead>
                                        <tr>
                                            {/*     <th>Start</th>
                                            <th>End</th> */}
                                            <th>Duration</th>
                                            <th>Play</th>
                                            <th>Download</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {recordList.map(
                                            (r: any, idx: number) => (
                                                <tr key={r.SessionId || idx}>
                                                    {/*   <td>
                                                        {r.ActualStartDate
                                                            ? new Date(
                                                                  r.ActualStartDate
                                                              ).toLocaleDateString()
                                                            : ""}{" "}
                                                        {r.ActualStartTime ||
                                                            ""}
                                                    </td>
                                                    <td>
                                                        {r.ActualEndDate
                                                            ? new Date(
                                                                  r.ActualEndDate
                                                              ).toLocaleDateString()
                                                            : ""}{" "}
                                                        {r.ActualEndTime || ""}
                                                    </td> */}
                                                    <td>
                                                        {r.ActualDurationFormatted ||
                                                            `${
                                                                r.ActualDurationMinutes ||
                                                                0
                                                            }m ${
                                                                r.ActualDurationSeconds ||
                                                                0
                                                            }s`}
                                                    </td>
                                                    <td>
                                                        {r.PlayURL ? (
                                                            <a
                                                                href={r.PlayURL}
                                                                target="_blank"
                                                                rel="noopener noreferrer">
                                                                Play
                                                            </a>
                                                        ) : (
                                                            "-"
                                                        )}
                                                    </td>
                                                    <td>
                                                        {r.DownloadUrl ? (
                                                            <a
                                                                href={
                                                                    r.DownloadUrl
                                                                }
                                                                target="_blank"
                                                                rel="noopener noreferrer">
                                                                Download
                                                            </a>
                                                        ) : (
                                                            "-"
                                                        )}
                                                    </td>
                                                </tr>
                                            )
                                        )}
                                    </tbody>
                                </table>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Resource;
// ...existing code...
